export const GET_SPECIAL_CONSIDERATION_SUBJECT_DETAILS = (params: string) =>
  `/${params}/request-details`;

export const GET_SUBJECT_DETAILS = (
  params: string,
  page: number | undefined,
  size: number | undefined
) => `/${params}/request-details/subjects?page=${page}&size=${size}`;

export const GET_DRAFT_SAVED_DATE_TIME = (params: string) => `/${params}/draft-saved-date-time`;
export const REQUEST_DETAILS = (requestUuid: string, uuid: string) =>
  `${requestUuid}/request-details/${uuid}`;

export const GET_TYPES_AND_REASONS = 'types-and-reasons';

export const GET_REVIEW_BY_UUID = (uuid: string) => `/${uuid}/review`

export const GET_SC_ACKNOWLEDGEMENT_REQUEST = (uuid: string) => `/${uuid}/request-acknowledgement`

export const GET_SPECIAL_CONSIDERATION_SUMMARY = (uuid: string) => `/${uuid}/summary`
